<template>
  <div v-if="ground.length > 0" class="w-full container-swiper-slider relative" 
  >
   <primary-slide :data-slides="ground" :config="config" />
  </div>
</template>

<script>
import { ref } from 'vue';
import PrimarySlide from './PrimarySlide.vue'

export default {
  name: "slider-swiper",
  components: {
   PrimarySlide
  },
  props: {
    bg: {
      type: Array,
      default: [],
    },
    dimension:{
      type:Object,
      default: () =>{
        return {
        "mobile":"300px",
        "lg": "280px",
        "xl":"400px"
        }}
    }
  },
  data() {
    return {
      ground: this.bg,
      visible: false,
      /*config:{
        navigation:true,
        effect: 'gl',
      }*/ 
      config:{
        navigation:true,
        effect: 'fade', 
      }
    };
  },
 
 
};
</script>

<style lang="scss" scoped>
.container-swiper-slider {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  height:v-bind('dimension.mobile');
  @screen lg{
    height: calc(100vw * (9/16) - v-bind('dimension.lg') );
  }
  @screen 3xl{
    height:calc(100vw * (9/16) - v-bind('dimension.xl') );
  }
  overflow: hidden;
}

</style>